"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
DamagedService.$inject = ['api'];
function DamagedService(api) {
}
exports.DamagedService = DamagedService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/damaged/services/damaged.js
// module id = 390
// module chunks = 0